import React from 'react';
import { Heading } from '@chakra-ui/react';
import { MainLayout } from '@src/components/layouts/MainLayout';

export const Loading = () => (
  <MainLayout>
    <Heading> Loading ....... </Heading>
  </MainLayout>
);
